
import { loaderService } from "../../../common/custom-loader/loader-service";
import { authKey, GET_ALL_TRAINING_MATERIAL, GET_ALL_TRAINING_MATERIAL_BY_CATEGORY, DOWNLOAD_DOCUMENT, DELETE_TRAINING_MATERIAL, PROCESS_MULTIPLE_WORK_FLOW, PROVIDE_TRAINING_MATERIAL_CLARIFICATION } from '../../../common/URLs';

import { getLocalStorageItem } from "../../../common/localStorageUtils";
import apiClient from "../../../axios";

export function getAllTrainingMaterial(setViewTraningMaterial) {
  loaderService.showLoader();
  apiClient
    .post(GET_ALL_TRAINING_MATERIAL,
      {

      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setViewTraningMaterial(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader();
    });
}

export function getAllTrainingMaterialByCategory(stakeHolderType, setViewTraningMaterial) {
  loaderService.showLoader();
  apiClient
    .post(GET_ALL_TRAINING_MATERIAL_BY_CATEGORY,
      {
        "stakeholderCategory": stakeHolderType,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setViewTraningMaterial(response.data);
      // console.log(response.data)
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader();
    });
}

export function deleteTrainingMaterial(item, setDeleteTraningMaterial) {
  loaderService.showLoader();
  apiClient
    .post(DELETE_TRAINING_MATERIAL,
      item,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setDeleteTraningMaterial(response.data);
      // console.log(response.data)
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader();
    });
}

export const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
  loaderService.showLoader();
  return fetch(DOWNLOAD_DOCUMENT,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        AuthKey: authKey,
      },
      body: JSON.stringify({
        "fileName": documentBlobName,
        "containerName": "resourcefiles",
        "file": ""
      })
    })
    .then((response) => response.blob()
    )
    .then((blob) => {
      if (type === "View") {
        const fileName = finalfileName
        const splittedName = fileName.split('.')
        const fileExtension = splittedName[splittedName.length - 1];
        let fileType;
        switch (fileExtension) {
          case 'pdf':
            fileType = 'application/pdf';
            break;
          case 'png':
            fileType = 'image/png';
            break;
          case 'jpg':
            fileType = 'image/jpeg';
            break;
          case 'jpeg':
            fileType = 'image/jpeg';
            break;
          default:
            fileType = 'application/octet-stream';
        }
        const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
        const newWindow = window.open(url, '_blank');
        newWindow.focus();
      }
      else {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = finalfileName;
        a.click();
        window.URL.revokeObjectURL(url);
      }
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader();
    });
}

export const knowledgeMultipleWorkFlow = (approvalArray, setKnowledgeWorkflow) => {
  apiClient
    .post(PROCESS_MULTIPLE_WORK_FLOW,
      {
        "processWorkflowRequest": approvalArray.map((item) => ({...item, userRole: localStorage.getItem('role'), approverName: localStorage.getItem('userName'),
          approverRole: localStorage.getItem('role')}))
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setKnowledgeWorkflow(response.data);
      console.log(response.data)
    })
    .catch(function (error) {
      console.log(error);
    });
}

export function provideTrainingMaterialClarification(updatedDetails, setTraningMaterialResponse) {
  loaderService.showLoader();
  apiClient
    .post(PROVIDE_TRAINING_MATERIAL_CLARIFICATION,
      {
        "getTrainingMaterialList": [updatedDetails]
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setTraningMaterialResponse(response.data);
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log("apiClientERROR", error);
      loaderService.hideLoader();
    });
}
